// packages/components/src/animationConstants.ts
import { TargetAndTransition, Transition } from 'framer-motion';

// --- CARD & SECTION ANIMATIONS ---
export const INNER_CARD_ANIMATE_RESTING: TargetAndTransition = {
  x: 0,
  y: 0,
  boxShadow: "none",
};

export const INNER_CARD_HOVER: TargetAndTransition = {
  x: -2,
  y: -2,
  boxShadow: "2px 2px 0px 0px rgb(17,24,39)",
};

export const INNER_CARD_TRANSITION_HOVER: Transition = {
    duration: 0.15,
    ease: "easeOut"
};